import useGraphqlQuery from '@elementary/common-ui/hooks/useGraphqlQuery';
import { INCIDENT_GRAPHQL_LINEAGE } from '@elementary/common-ui/constants/queryKeys';
import useSelectedEnv from '@elementary/common-ui/hooks/useSelectedEnv';
import type { HopLimit } from '@elementary/common-ui/components/lineageGraph/types';
import { getIncidentLineageQuery } from '../api';
import type { IncidentLineage } from '../types';

const useIncidentLineage = (
  incidentId: string | undefined,
  hopLimit: HopLimit,
  enabled = true,
) => {
  const selectedEnvId = useSelectedEnv();

  const { data, isLoading, isFetching, error } = useGraphqlQuery<{
    incidentV2: { id: string; lineage: IncidentLineage } | null;
  }>({
    queryKey: [
      INCIDENT_GRAPHQL_LINEAGE,
      incidentId,
      selectedEnvId,
      hopLimit.upstream ?? 0,
      hopLimit.downstream ?? 0,
    ],
    query: getIncidentLineageQuery,
    variables: {
      id: incidentId,
      upstream: hopLimit.upstream ?? 0,
      downstream: hopLimit.downstream ?? 0,
    },
    enabled: enabled && !!incidentId,
    keepPreviousData: true,
  });

  const raw = data?.incidentV2;
  const lineage =
    raw && incidentId && raw.id === incidentId ? raw.lineage : undefined;

  return {
    lineage,
    isLoading,
    isFetching,
    error,
  };
};

export default useIncidentLineage;
